<a routerLink="/">PerfumeDB</a>

<button type="button" *ngIf="menu.showHeaderToggleButton" (click)="toggle()">
  <fa-icon [icon]="hamburger"></fa-icon>
</button>
